import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import { usePresentationBooking } from '../../../../../../../hooks/usePresentationBooking';
import { Slot } from '../../../../../../../interfaces/interfaces';
import { setPostRegistrationAction } from '../../../../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../../../../reduxToolkit/typedRedux';
import VyButton from '../../../../../../common/VyButton';
import VyTooltip from '../../../../../../common/VyTooltip';

interface PresentationJoinButtonProps {
  slot: Slot;
  onClick?: () => void;
  customHtmlColor?: string;
}

export const PresentationJoinButton = (props: PresentationJoinButtonProps) => {
  const { slot, onClick, customHtmlColor } = props;

  const { canJoinPresentation } = usePresentationBooking();
  const { t } = useTranslation('event');
  const dispatch = useDispatch();

  const event = useSelector((state) => state.common.event);
  const user = useSelector((state) => state.common.user);

  /**
   * The signup modal sets the user in store, but when the onClick(which is join) is executed, the store has not been updated yet, causing a redirect to the signup page.
   * This approach ensures that a user is set before joining.
   */
  const [joinAfterSignup, setJoinAfterSignup] = useState(false);

  function handleClick(e: any) {
    e.stopPropagation();

    if (user) {
      onClick?.();
    } else {
      dispatch(setPostRegistrationAction(() => setJoinAfterSignup(true)));
    }
  }

  useEffect(() => {
    if (user && joinAfterSignup) {
      onClick?.();
    }
  }, [user, joinAfterSignup]);

  if (canJoinPresentation(slot))
    return (
      <div className="flex" style={{ scale: '.9' }} onClick={handleClick}>
        <VyTooltip title={t('presentation-ticket.join-presentation-tooltip')}>
          <VyButton compact className="flex items-center" event={event}>
            {t('common:join')} <MdKeyboardArrowRight />
          </VyButton>
        </VyTooltip>
      </div>
    );
  return null;
};
